import React, {useEffect, useMemo} from "react";
import {Card, CardBody, CardHeader, CardHeaderToolbar, ModalProgressBar,} from "../../../_metronic/_partials/controls";
import BasketsTable from "./BasketsTable";
import {DeleteDialog} from "../../../_metronic/_partials/controls/delete-modal/DeleteDialog";
import {useBasketsUIContext} from "./BasketsUIContext";
import {shallowEqual, useSelector} from "react-redux";
import {deleteProduct} from "./crud/basketCrud";
import {useHistory, useLocation} from "react-router-dom";

export default function BasketsListCmp() {

    const basketContext = useBasketsUIContext();
    const basketProps = useMemo(() => {
        return {
            setOpenDelete: basketContext.setOpenDelete,
            fetchData: basketContext.fetchData,
            setOpenError: basketContext.setOpenError,
            setError: basketContext.setError,
            baskets: basketContext.baskets,
            id: basketContext.id,
            data: basketContext.data,
        }
    });

    let query = useQuery();

    function useQuery() {
        return new URLSearchParams(useLocation().search);
    }

    const history = useHistory();

    function handlePageChange(page) {
        history.push(`${history.location.pathname}?page=${page}`)
    }

    const {actionsLoading} = useSelector(
        (state) => ({
            actionsLoading: state.actionsLoading.actionsLoading,
        }),
        shallowEqual
    );

    useEffect(() => {
        basketContext.fetchData();
    }, []);

    const handleDelete = () => {
        deleteProduct(basketProps.id).then(() => {
            basketProps.setOpenDelete(false);
            basketProps.fetchData();
        }).catch(() => {
            basketProps.setOpenDelete(false);
            basketProps.setOpenError(true);
            basketProps.setError("Something went wrong!");
        });
    };

    return (
        <>
            {actionsLoading && <ModalProgressBar/>}
            <Card>
                <CardHeader title="لیست سبدها">
                    <CardHeaderToolbar>
                        <button
                            type="button"
                            className="btn btn-warning ml-2"
                            onClick={() => {
                                basketProps.fetchData(1)
                            }}>
                            بارگزاری مجدد
                        </button>
                    </CardHeaderToolbar>
                </CardHeader>
                <CardBody>

                    <BasketsTable
                        baskets={basketProps.baskets}
                        data={basketProps.data}
                        handlePageChange={handlePageChange}
                        activePage={query.get("page") ? query.get("page") : 1}
                    />

                    {basketProps.openDelete &&
                    <DeleteDialog
                        show={basketProps.openDelete}
                        onHide={() => {
                            basketProps.setOpenDelete(false);
                            basketProps.fetchData(1);
                        }}
                        handleDelete={handleDelete}
                    />
                    }

                </CardBody>
            </Card>
        </>
    )
}